import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Logo from "../../public/assets/images/icons/rofda-logo.png";
import office1 from "../../public/assets/images/bg/office1.png";
import { AppContext } from "../Redux/ContextProvider";

const Header = ({ data, location, social }) => {
  const { appState, dispatch } = useContext(AppContext);
  const { loginInfo, loginLoader, loginMessage } = appState;

  const loggedInEmail = localStorage.getItem("loggedInEmail");
  // console.log(loggedInEmail);

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const isSticky = (e) => {
    const header = document.querySelector("header");
    const scrollTop = window.scrollY;
    scrollTop >= 200
      ? header.classList.add("sticky")
      : header.classList
        ? header.classList.remove("sticky")
        : header.classList.add("sticky");
  };

  /*----for single sidebar event use one state-------*/
  const [sidebar, setSidebar] = useState(false);
  const [showSearch, setshowSearch] = useState(false);
  const [showMobileMenu, setMobileMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  // const [showMobileSubMenu, setMobileSubMenu] = useState(false);
  // const handleMobileSubMenu = () => {
  //   if (showMobileSubMenu === false || showMobileSubMenu === 0) {
  //     setMobileSubMenu(1);
  //   } else {
  //     setMobileSubMenu(false);
  //   }
  // };
  const handleMobileMenu = () => {
    if (showMobileMenu === false || showMobileMenu === 0) {
      setMobileMenu(1);
    } else {
      setMobileMenu(false);
    }
  };
  const showSidebarMenu = () => {
    if (sidebar === false || sidebar === 0) {
      setSidebar(1);
    } else {
      setSidebar(false);
    }
  };
  const handleSearchbarBtn = () => {
    if (showSearch === false || showSearch === 0) {
      setshowSearch(1);
    } else {
      setshowSearch(false);
    }
  };

  return (
    <React.Fragment>
      <div
        className={
          sidebar === 1
            ? "menu-toggle-btn-full-shape show-sidebar"
            : "menu-toggle-btn-full-shape"
        }
      >
        <div className="menu-toggle-wrap bg-white">
          <div className="sidebar-top-area d-flex justify-content-between align-items-center">
            <div className="sidebar-logo rounded">
              <Link to="#">
                  {" "}
                  <img src={Logo} alt="logo-size" className="logo-size" />
              </Link>
            </div>
            <div className="cross-icon" onClick={showSidebarMenu}>
              <i className="bx bx-x" />
            </div>
          </div>
          <div className="sidebar-body">
            <div className="address-card mb-4">
              <div className="content">
                <div className="header">
                  <div className="location">
                    <svg
                      width={18}
                      height={22}
                      viewBox="0 0 18 22"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M9 22C9 22 17.25 14.1818 17.25 8.25C17.25 6.06196 16.3808 3.96354 14.8336 2.41637C13.2865 0.869194 11.188 0 9 0C6.81196 0 4.71354 0.869194 3.16637 2.41637C1.61919 3.96354 0.75 6.06196 0.75 8.25C0.75 14.1818 9 22 9 22ZM9 12.375C7.90598 12.375 6.85677 11.9404 6.08318 11.1668C5.3096 10.3932 4.875 9.34402 4.875 8.25C4.875 7.15598 5.3096 6.10677 6.08318 5.33318C6.85677 4.5596 7.90598 4.125 9 4.125C10.094 4.125 11.1432 4.5596 11.9168 5.33318C12.6904 6.10677 13.125 7.15598 13.125 8.25C13.125 9.34402 12.6904 10.3932 11.9168 11.1668C11.1432 11.9404 10.094 12.375 9 12.375Z" />
                    </svg>
                  </div>
                  <h3>{location.City}</h3>
                </div>
                <ul className="address-list">
                  <li>
                    <span>Address: </span>
                    {location.AddressLine1} {location.AddressLine2}{" "}
                    {location.City}, {location.StateName} {location.ZipCode}
                  </li>
                  <li>
                    <span>Phone:</span> +{location.StorePhoneNumber}
                  </li>
                  <li>
                    <span>Email:</span> {location.StoreEmail}
                  </li>
                </ul>
              </div>
              {/* <img src={office1} alt="webco" /> */}
            </div>
            <div className="blog-widget-item mb-0">
                <h5 className="blog-widget-title mb-1">Follow Us</h5>
                <p className="para">Follow us on Social Network</p>
                <div className="blog-widget-body">
                  <ul className="follow-list d-flex flex-row align-items-start gap-4">
                    {social.facebook_url ? (
                      <li>
                        <a href={`${social.facebook_url}`}>
                          <i className="bx bxl-facebook" />
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {social.twitter_url ? (
                      <li>
                        <a href={`${social.twitter_url}`}>
                          <i className="bx bxl-twitter" />
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {social.linkedin_url ? (
                      <li>
                        <a href={`${social.linkedin_url}`}>
                          <i className="bx bxl-linkedin" />
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {social.pintrest_url ? (
                      <li>
                        <a href={`${social.pintrest_url}`}>
                          <i className="bx bxl-pinterest" />
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={showSearch === 1 ? "mobile-search slide" : "mobile-search"}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-11">
              <label>What are you lookking for?</label>
              <input
                type="text"
                placeholder="Search Products, Category, Brand"
              />
            </div>
            <div className="col-1 d-flex justify-content-end align-items-center gap-2">
              <div className="search-cross-btn">
                <i className="bx bx-search-alt-2" />
              </div>
              <div className="search-cross-btn" onClick={handleSearchbarBtn}>
                <i className="bi bi-x" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <header className="header-area style-3">
        <div className="header-logo">
          <Link to="/">
              <img alt="webco" src={Logo} className="img-fluid" />
          </Link>
        </div>
        <div
          className={showMobileMenu === 1 ? "main-nav mobile-menu-main show-menu" : "mobile-menu-main main-nav"}
        >
          <div className="mobile-logo-area mb-20 d-lg-none d-flex justify-content-between align-items-center">
            <div className="mobile-logo-wrap ">
              <Link to="/">
                <img alt="webco" src={Logo} className="logo-size" />
              </Link>
            </div>
            <div onClick={handleMobileMenu} className="menu-close-btn">
              <i
                className={
                  showMobileMenu === 1
                    ? "bi bi-x-lg bi-chevron-down"
                    : "bi bi-x-lg bi-chevron-up"
                }
              />
            </div>
          </div>
          <ul className="menu-list">
            {data &&
              data.length &&
              data.map((info) => {
                return (
                  <li className="menu-item-has-children" key={info.menu_id}>
                    <Link to={`/${info.menu_url}`} className="drop-down">
                      <span>{info.menu_name}</span>
                    </Link>
                    {info.submenu && info.submenu.length > 0 && (
                      <React.Fragment>
                        <i
                    className="bi bi-chevron-down dropdown-icon"
                    onClick={() => setOpenSubMenu(openSubMenu === info.menu_id ? null : info.menu_id)}
                  />
                  <ul className={openSubMenu === info.menu_id ? "sub-menu d-block" : "sub-menu d-none"}>
                          {info.submenu.map((val, index) => {
                            return (
                              <li key={index}>
                                <Link to={`/${val.menu_url}`}>
                                  {val.menu_name}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </React.Fragment>
                    )}
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="nav-right d-flex align-items-center gap-4">
          <div className="mobile-menu-btn d-lg-none d-block">
            <h5
              className="text-dark mb-0"
              onClick={handleMobileMenu}
              style={{ cursor: "pointer" }}
            >
              <span>MENU</span>
              <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M20 18a1 1 0 0 1 .117 1.993L20 20H4a1 1 0 0 1-.117-1.993L4 18zm0-7a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0-7a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"/></g></svg>
              </div>
            </h5>
          </div>
          <div className="hotline d-xxl-flex d-none">
            <div className="hotline-icon">

              <svg xmlns="http://www.w3.org/2000/svg" width={34}
                height={34} viewBox="0 0 24 24"><path fill="currentColor" d="m16.484 11.976l6.151-5.344v10.627zm-7.926.905l2.16 1.875c.339.288.781.462 1.264.462h.017h-.001h.014c.484 0 .926-.175 1.269-.465l-.003.002l2.16-1.875l6.566 5.639H1.995zM1.986 5.365h20.03l-9.621 8.356a.6.6 0 0 1-.38.132h-.014h.001h-.014a.6.6 0 0 1-.381-.133l.001.001zm-.621 1.266l6.15 5.344l-6.15 5.28zm21.6-2.441c-.24-.12-.522-.19-.821-.19H1.859a1.9 1.9 0 0 0-.835.197l.011-.005A1.86 1.86 0 0 0 0 5.855v12.172a1.86 1.86 0 0 0 1.858 1.858h20.283a1.86 1.86 0 0 0 1.858-1.858V5.855c0-.727-.419-1.357-1.029-1.66l-.011-.005z" /></svg>

            </div>
            <div className="hotline-info">
              <span>Mail Us</span>
              <h6>
                <a href={`mailto:${location.StoreEmail}`}>
                  {location.StoreEmail}
                </a>
              </h6>
            </div>
          </div>
          {loggedInEmail !== null ? (
            <>
              <div className="eg-btn log-out-wrap">
                <Link
                  to="/login"
                  onClick={() => {
                    localStorage.removeItem("loggedInEmail");
                    window.location.reload("/login");
                  }}
                >
                  <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 15 15"><path fill="none" stroke="currentColor" d="m13.5 7.5l-3 3.25m3-3.25l-3-3m3 3H4m4 6H1.5v-12H8" strokeWidth="1"/></svg></div>
                  <span>Logout</span>
                </Link>

                {/* <React.Fragment>
                  <i className="bi bi-chevron-down dropdown-icon" />
                </React.Fragment> */}
              </div>
            </>
          ) : (
            <div className="eg-btn login-wrap">
              <Link to="/login">
              <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 21v-2h7V5h-7V3h9v18zm-2-4l-1.375-1.45l2.55-2.55H3v-2h8.175l-2.55-2.55L10 7l5 5z"/></svg></div>
              <span>Login</span>
              </Link>
            </div>
          )}

          <div className="eg-btn btn--primary2 header-btn log-out-btn">
            <Link to="/contact-us">
              <a>LET'S TALK</a>
            </Link>
          </div>
          <div className="header-icons d-flex align-items-center">
            <div className="sidebar-btn" onClick={showSidebarMenu}>
              <i className="bi bi-list" />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
